import { Grid, Menu } from "antd";
import {
  BrokerIcon,
  ClientData,
  Dashboard,
  Document,
  LeadReport,
  ManageLocation,
  ManageProperty,
  SalesPipeline,
  SignedAgreements,
  Users,
  Occupancy,
  ClientStatement,
  ManageBusiness,
  GenerationOfInvoice,
  InvoiceList,
  KycStatus,
  RentalBill,
  Analytics,
  OfficeBooking,
  ManageRoles,
  Operations
} from "assets/svg/sideNavigation/navigationicon";
import navigationConfig from "configs/NavigationConfig";
import { NAV_TYPE_SIDE, SIDE_NAV_LIGHT } from "constants/ThemeConstant";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { onMobileNavToggle } from "redux/actions/Theme";
import utils from "utils";
import { PlusCircleOutlined } from "@ant-design/icons";
import Icon from "../util-components/Icon";
import IntlMessage from "../util-components/IntlMessage";

const { SubMenu } = Menu;
const { useBreakpoint } = Grid;

const setLocale = (isLocaleOn, localeKey) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();

const setDefaultOpen = (key) => {
  let keyList = [];
  let keyString = "";
  if (key) {
    const arr = key.split("-");
    for (let index = 0; index < arr.length; index++) {
      const elm = arr[index];
      index === 0 ? (keyString = elm) : (keyString = `${keyString}-${elm}`);
      keyList.push(keyString);
    }
  }
  return keyList;
};

/**
 *
 * @param {string} Key
 * @returns
 */
function FetchIconByKey(key) {
  switch (key) {
    case "salesPipeline":
      return SalesPipeline;
    case "broker-icon":
      return BrokerIcon;
    case "client-data":
      return ClientData;
    case "dashboard":
      return Dashboard;
    case "document":
      return Document;
    case "lead-report":
      return LeadReport;
    case "marketing":
      return LeadReport;
    case "manage-location":
      return ManageLocation;
    case "manage-property":
      return ManageProperty;
    case "signed-agreement":
      return SignedAgreements;
    case "users":
      return Users;
    case "occupancy":
      return Occupancy;
    case "client-statement":
      return ClientStatement;
    case "manage-business":
      return ManageBusiness;
    case "generation-of-invoice":
      return GenerationOfInvoice;
    case "invoice-list":
      return InvoiceList;
    case "rental-bills":
      return RentalBill;
    case "kyc-status":
      return KycStatus;
    case "analytics":
      return Analytics
    case "officeBooking":
      return OfficeBooking
    case "manageRoles":
      return ManageRoles
      case "operations":
        return Operations
    case "master-suite":
      return ManageProperty;
    default:
      return PlusCircleOutlined;
  }
}

const SideNavContent = (props) => {
  const {
    sideNavTheme,
    routeInfo,
    hideGroupTitle,
    localization,
    onMobileNavToggle,
  } = props;

  /**
   * @type [Array<SideMenuItem>]
   */
  const [sideMenuItems, setSideMenuItems] = useState([]);

  useEffect(() => {
    /**
     * @type Array<SideMenuItem>
     */
    let list = [...(props?.newSideMenuItems || [])]
      .filter((item) => {
        if (!item?.submenu?.length && !item.path?.trim()) return false;
        return true;
      })
      .sort((a, b) => a.order - b.order);
    const obj = [
      {
        submenu: list,
        key: "extra",
        breadcrumb: false,
        icon: "dashboard",
        path: navigationConfig[0].path,
        name: "",
      },
    ];
    setSideMenuItems(obj);
  }, [props]);


  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes("lg");
  const closeMobileNav = () => {
    if (isMobile) {
      onMobileNavToggle(false);
    }
  };

  return (
    <Menu
      theme={sideNavTheme === SIDE_NAV_LIGHT ? "light" : "dark"}
      mode="inline"
      style={{ height: "100%", borderRight: 0 }}
      defaultSelectedKeys={[routeInfo?.key]}
      defaultOpenKeys={setDefaultOpen(routeInfo?.key)}
      className={hideGroupTitle ? "hide-group-title" : ""}
    >
      {sideMenuItems.map((menu) =>
        menu.submenu?.length > 0 ? (
          <Menu.ItemGroup key={menu.key || menu.code}>
            {menu?.submenu?.map((subMenuFirst) =>
              subMenuFirst.submenu?.length > 0 ? (
                <SubMenu
                  icon={
                    subMenuFirst.icon ? (
                      <Icon type={FetchIconByKey(subMenuFirst.icon)} />
                    ) : null
                  }
                  key={subMenuFirst.key || subMenuFirst.code}
                  title={setLocale(localization, subMenuFirst.name)}
                >
                  {subMenuFirst?.submenu?.map((subMenuSecond) => (
                    <Menu.Item key={subMenuSecond.key || subMenuSecond.code}>
                      {subMenuSecond.icon ? (
                        <Icon type={FetchIconByKey(subMenuFirst.icon)} />
                      ) : null}
                      <span>{setLocale(localization, subMenuSecond.name)}</span>
                      <Link
                        onClick={() => closeMobileNav()}
                        to={subMenuSecond.path || "/app/home_new"}
                      />
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item key={subMenuFirst.key || subMenuFirst.code}>
                  {subMenuFirst.icon ? (
                    <Icon type={FetchIconByKey(subMenuFirst.icon)} />
                  ) : null}
                  <span>{setLocale(localization, subMenuFirst.name)}</span>
                  <Link
                    onClick={() => closeMobileNav()}
                    to={subMenuFirst.path || "/app/home_new"}
                  />
                </Menu.Item>
              )
            )}
          </Menu.ItemGroup>
        ) : (
          <Menu.Item key={menu.key || menu.code}>
            {menu.icon ? <Icon type={FetchIconByKey(menu.icon)} /> : null}
            <span>{menu?.name}</span>
            {menu.path ? (
              <Link
                onClick={() => closeMobileNav()}
                to={menu.path || "/app/home_new"}
              />
            ) : null}
          </Menu.Item>
        )
      )}
    </Menu>
  );
};

const TopNavContent = (props) => {
  const { topNavColor, localization } = props;
  console.log('navigationConfig', navigationConfig);
  return (
    <Menu mode="horizontal" style={{ backgroundColor: topNavColor }}>
      {navigationConfig.map((menu) =>
        menu.submenu.length > 0 ? (
          <SubMenu
            key={menu.key}
            popupClassName="top-nav-menu"
            title={
              <span>
                {menu.icon ? <Icon type={menu?.icon} /> : null}
                <span>{setLocale(localization, menu.title)}</span>
              </span>
            }
          >
            {menu.submenu.map((subMenuFirst) =>
              subMenuFirst.submenu.length > 0 ? (
                <SubMenu
                  key={subMenuFirst.key}
                  icon={
                    subMenuFirst.icon ? (
                      <Icon type={subMenuFirst?.icon} />
                    ) : null
                  }
                  title={setLocale(localization, subMenuFirst.title)}
                >
                  {subMenuFirst.submenu.map((subMenuSecond) => (
                    <Menu.Item key={subMenuSecond.key}>
                      <span>
                        {setLocale(localization, subMenuSecond.title)}
                      </span>
                      <Link to={subMenuSecond.path} />
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item key={subMenuFirst.key}>
                  {subMenuFirst.icon ? (
                    <Icon type={subMenuFirst?.icon} />
                  ) : null}
                  <span>{setLocale(localization, subMenuFirst.title)}</span>
                  <Link to={subMenuFirst.path} />
                </Menu.Item>
              )
            )}
          </SubMenu>
        ) : (
          <Menu.Item key={menu.key}>
            {menu.icon ? <Icon type={menu?.icon} /> : null}
            <span>{setLocale(localization, menu?.title)}</span>
            {menu.path ? <Link to={menu.path} /> : null}
          </Menu.Item>
        )
      )}
    </Menu>
  );
};

const MenuContent = (props) => {
  return props.type === NAV_TYPE_SIDE ? (
    <SideNavContent {...props} />
  ) : (
    <TopNavContent {...props} />
  );
};

const mapStateToProps = ({ theme }) => {
  const { sideNavTheme, topNavColor } = theme;
  return { sideNavTheme, topNavColor };
};

export default connect(mapStateToProps, { onMobileNavToggle })(MenuContent);
